'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _UIGrid = require('UIComponents/grid/UIGrid');

var _UIGrid2 = _interopRequireDefault(_UIGrid);

var _UIGridItem = require('UIComponents/grid/UIGridItem');

var _UIGridItem2 = _interopRequireDefault(_UIGridItem);

var _UIFlex = require('UIComponents/layout/UIFlex');

var _UIFlex2 = _interopRequireDefault(_UIFlex);

var _H = require('UIComponents/elements/headings/H5');

var _H2 = _interopRequireDefault(_H);

var _H3 = require('UIComponents/elements/headings/H7');

var _H4 = _interopRequireDefault(_H3);

var _Small = require('UIComponents/elements/Small');

var _Small2 = _interopRequireDefault(_Small);

var _FormattedMessage = require('I18n/components/FormattedMessage');

var _FormattedMessage2 = _interopRequireDefault(_FormattedMessage);

var _PriceDisplay = require('pricing-pages-unified-ui/components/common/pricing/PriceDisplay');

var _PriceDisplay2 = _interopRequireDefault(_PriceDisplay);

var _theme = require('HubStyleTokens/theme');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FeeRow = (0, _styledComponents2.default)(_UIGrid2.default).withConfig({
  displayName: 'PriceBreakdownRow__FeeRow'
})(['padding:1em 12px;align-items:center;&.row{margin:0 0 10px;}&.price-row__total{background-color:', ';padding:1.75em 0.85em;}'], _theme.GYPSUM);

var CrossedOutPrice = (0, _styledComponents2.default)(_PriceDisplay2.default).withConfig({
  displayName: 'PriceBreakdownRow__CrossedOutPrice'
})(['color:', ';font-size:16px;line-height:27px;text-decoration:line-through;'], _theme.PANTERA);

var DiscountedPrice = (0, _styledComponents2.default)(_PriceDisplay2.default).withConfig({
  displayName: 'PriceBreakdownRow__DiscountedPrice'
})(['color:', ';font-size:20px;font-weight:500;line-height:27px;padding-left:8px;'], _theme.OZ);

var PriceBreakdownRow = function PriceBreakdownRow(_ref) {
  var text = _ref.text,
      costPerUnitSubtext = _ref.costPerUnitSubtext,
      price = _ref.price,
      priceDisclaimer = _ref.priceDisclaimer,
      currencyCode = _ref.currencyCode,
      isMonthly = _ref.isMonthly,
      isYearly = _ref.isYearly,
      isTotal = _ref.isTotal,
      fullPrice = _ref.fullPrice;
  return _react2.default.createElement(
    FeeRow,
    { className: isTotal && 'price-row__total' },
    _react2.default.createElement(
      _UIGridItem2.default,
      { size: 6, className: 'text-left' },
      _react2.default.createElement(
        _UIFlex2.default,
        { align: 'start', justify: 'center', direction: 'column', wrap: 'nowrap' },
        _react2.default.createElement(
          'div',
          null,
          isTotal ? _react2.default.createElement(
            _H4.default,
            { style: { margin: 0 } },
            text
          ) : _react2.default.createElement(
            'p',
            { style: { margin: 0 } },
            text
          ),
          _react2.default.createElement(
            _Small2.default,
            { style: { margin: 0, fontWeight: 400 } },
            costPerUnitSubtext
          )
        )
      )
    ),
    _react2.default.createElement(
      _UIGridItem2.default,
      { size: 6, className: 'text-right' },
      _react2.default.createElement(
        _UIFlex2.default,
        {
          align: 'end',
          justify: 'center',
          direction: 'column',
          wrap: 'nowrap',
          className: 'price-row__flex'
        },
        _react2.default.createElement(
          _H2.default,
          { style: { margin: 0 } },
          fullPrice && fullPrice > price ? _react2.default.createElement(
            _react.Fragment,
            null,
            _react2.default.createElement(CrossedOutPrice, { currencyCode: currencyCode, price: fullPrice }),
            _react2.default.createElement(DiscountedPrice, { currencyCode: currencyCode, price: price })
          ) : _react2.default.createElement(_PriceDisplay2.default, { currencyCode: currencyCode, price: price }),
          (isMonthly || isYearly) && _react2.default.createElement(_FormattedMessage2.default, {
            message: 'pricingPage.calculator.priceDisplay.' + (isMonthly ? 'perMonth' : 'perYear')
          })
        ),
        _react2.default.createElement(
          _Small2.default,
          { style: { margin: 0, fontWeight: 400 } },
          priceDisclaimer
        )
      )
    )
  );
};

PriceBreakdownRow.propTypes = {
  text: _react.PropTypes.node.isRequired,
  costPerUnitSubtext: _react.PropTypes.node,
  price: _react.PropTypes.number.isRequired,
  currencyCode: _react.PropTypes.string.isRequired,
  priceDisclaimer: _react.PropTypes.node,
  isMonthly: _react.PropTypes.bool,
  isYearly: _react.PropTypes.bool,
  isTotal: _react.PropTypes.bool,
  fullPrice: _react.PropTypes.number
};

exports.default = PriceBreakdownRow;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/components/calculator/PriceBreakdownRow.js
// module id = 580
// module chunks = 3 4